    angular
        .module('qkr')
        .controller('storefrontController', storeFrontController);
    function storeFrontController($scope, $rootScope, $routeSegment, outletService, merchantResponseData, outletData,
                                  merchantService, messageService, imageService, FormHelper, utils, $uibModal,
                                  gettextCatalog, appConfig, $filter, APP_CONSTANT, $log,
                                  integrationSettingsService, integrationHelperService) {
        const vm = $scope;

        vm.$routeSegment = $routeSegment; // Used to know what we've selected
        vm.saving = false;
        vm.merchantLoaded = false;
        vm.countries = [];
        vm.qrImageWidth = 80;
        vm.isMCAdmin = appConfig.isMCAdmin;
        vm.isElevatedUser = appConfig.isElevatedUser;
        vm.showPOSIntegrationOptions = false;
        vm.openingHoursConfig = {};
        vm.showOpenHoursWarning = false;
        vm.useMerchantSettings = false;
        vm.isCharity = false;
        vm.maxLength = 255;

        // TODO this was necessary because angular/js problem with scope it can be avoid...
        // TODO if we use vm = this as controller, do not use $scope as the route of your controller
        vm.business = {useOpeningHour: false};

        const merchantInfo = merchantResponseData;
        $rootScope.$broadcast('reloadDashboard');

        // Help with errors and validation
        const formHelper = new FormHelper($scope);

        vm.showOrderReadySettings = function() {
            return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showOrderReadySettings');
        };

        vm.showHomeDelivery = function() {
            return merchantService.behaviour($rootScope.merchantInfo, 'storeFrontPage.showHomeDelivery');
        };

        vm.init = function() {
            vm.$routeSegment = $routeSegment;

            vm.form = {};
            vm.merchantLoaded = false;

            vm.dropdownYesOrNo = [
                {name: ($filter('translate')(APP_CONSTANT.YES)), value: true},
                {name: ($filter('translate')(APP_CONSTANT.NO)), value: false}
            ];

            vm.dropdownAlphanumeric = [
                {name: ($filter('translate')(APP_CONSTANT.ALPHANUMERIC)), value: APP_CONSTANT.ALPHANUMERIC},
                {name: ($filter('translate')(APP_CONSTANT.NUMERIC)), value: APP_CONSTANT.NUMERIC}
            ];

            vm.open = outletData.open;
            vm.form.logoUrl = imageService.fullImageUrl(outletData.logoUrl);
            vm.form.coverImageUrl = imageService.fullImageUrl(outletData.coverImageUrl);
            vm.form.merchantPurchaseThankYouMessage = outletData.merchantPurchaseThankYouMessage;
            vm.form.purchaseThankYouMessage = outletData.purchaseThankYouMessage;
            vm.form.merchantOrderReadyMessage = outletData.merchantOrderReadyMessage;
            vm.form.orderReadyMessage = outletData.orderReadyMessage;
            vm.form.phoneDisplayName = outletData.name; // Get from outlet name
            vm.form.homeDeliveryEnabled = outletData.homeDeliveryEnabled;

            vm.form.latitude = outletData.latitude;
            vm.form.longitude = outletData.longitude;
            vm.form.country = outletData.country;
            vm.form.timezoneId = outletData.timezone;
            vm.form.currency = outletData.currencyIsoCode;
            vm.form.storeId = outletData.storeId;

            vm.form.merchantInfo = $rootScope.merchantInfo;
            // new integration settings
            const flattenData = integrationHelperService.convertServerDataToFlatten(outletData);
            const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
            // same outlet creation rule, old code rules,
            vm.isStoreIdVisible = integrationDetails.isPos && !integrationDetails.isDemo
                && !integrationDetails.isQuadranet;
            vm.isOutletIdVisible = integrationDetails.isQuadranet;
            // end new integration settings
            // old code rules, after remove pos from this controller
            vm.isCharity = vm.form.merchantInfo.businessCategory &&
                vm.form.merchantInfo.businessCategory.name === 'Charity' &&
                !integrationDetails.isPos;

            vm.form.outletOpeningHours = outletData.options.outletOpeningHours;

            if (outletData.contactDetails) {
                vm.form.addressLine1 = outletData.contactDetails.addressLine1;
                vm.form.addressLine2 = outletData.contactDetails.addressLine2;
                vm.form.city = outletData.contactDetails.city;
                vm.form.state = outletData.contactDetails.state;
                vm.form.postalcode = outletData.contactDetails.postalcode;

                vm.form.phoneNumber = outletData.contactDetails.phoneNumber;
                vm.form.website = outletData.contactDetails.website;
                vm.form.email = outletData.contactDetails.email;

                vm.stateDisplayName = outletData.contactDetails.country.stateDisplayName;

                vm.postcodeDisplayName = gettextCatalog
                    .getString(outletData.contactDetails.country.postcodeDisplayName);
            } else {
                messageService.log('For some reason contact details are missing');
                $log.error('Contact details are missing, ' +
                    'something went wrong and the server should have sent the country');
            }

            if (utils.hasNoValue(vm.stateDisplayName)) {
                vm.stateDisplayName = gettextCatalog.getString('State/County');
            }

            if (!vm.postcodeDisplayName) {
                vm.postcodeDisplayName = gettextCatalog.getString('Postcode');
            }

            if (outletData.options.useCustomThankYouMessage) {
                vm.form.useCustomThankYouMessage = true;
            } else {
                vm.form.useCustomThankYouMessage = false;
            }

            if (outletData.options.useCustomOrderReadyMessage) {
                vm.form.useCustomOrderReadyMessage = true;
            } else {
                vm.form.useCustomOrderReadyMessage = false;
            }

            vm.stateSelectableValues = [];

            // If the country is missing show an message log
            if (outletData.country) {
                angular.forEach(outletData.country.stateSelectableValues, function(value, key) {
                    this.push(value.name);
                }, vm.stateSelectableValues);
            } else {
                messageService.warning('Country is missing, there is something wrong with this contact details');
            }

            if (outletData.defaultScanId) {
                vm.defaultScanId = outletData.defaultScanId;
                vm.viewQrCode = true;
                vm.imgSrc = window.QKR_SERVER_HOST + '/' + window.QKR_SERVER_PATH +
                    '/qrCode/genQrCode?id=' + vm.defaultScanId;
            } else {
                vm.viewQrCode = false;
            }
            if (!merchantService.behaviour(merchantInfo, 'storefrontContacts.noOpeningHours')) {
                setSelectorHours();
                vm.openingHours = [];

                if (outletData.options.outletOpeningHours) {
                    vm.outletOpeningHours =
                        convertOpeningHoursMapToArray(outletData.options.outletOpeningHours.openDays);
                    vm.business.useOpeningHours = true;
                } else {
                    outletService.getDefaultOpeningHours().then((data) => {
                        vm.outletOpeningHours = convertOpeningHoursMapToArray(data.days.openDays);
                        vm.business.useOpeningHours = false;
                    });
                }
            }
            vm.merchantLoaded = true;
        };

        vm.showOpeningHours = function() {
            return !merchantService.behaviour(merchantInfo, 'storefrontContacts.noOpeningHours');
        };

        vm.editImage = function(imageId, $files) {
            imageService.editingImageId = imageId;
            if (imageId === 'cover') {
                vm.selectImageModal(2.664, 666, '' + imageId + '' + Math.random(), $files); // Wide-image
                // Url
            } else {
                vm.selectImageModal(1, 250, '' + imageId + '' + Math.random(), $files); // Logo
            }
        };
        /*
         * Function to open the choose image modal dialog
         */
        vm.selectImageModal = function(ratio, absoluteSize, imageName, $files) {
            imageService.editingImageReferenceName = imageName;
            $rootScope.requiredAspectRatio = ratio;
            $rootScope.scaledWidthAbsolute = absoluteSize;

            const modalInstance2 = $uibModal.open({
                template: require('../templates/imageUpload.html'),
                controller: 'ImageController',
                windowClass: 'modal-image modal-borderless draggable',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    inputImage() {
                        return $files;
                    }
                }

            });

            modalInstance2.result.then((selectedItem) => {
                if (selectedItem !== 'cancel') {
                    const editingImageId = imageService.editingImageId;

                    var imageSubmitForm;
                    if (editingImageId === 'cover') {
                        vm.form.coverImageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();

                        var imageSubmitForm = angular.copy(vm.form);
                        delete imageSubmitForm.logoUrl;
                        delete imageSubmitForm.description;
                    } else {
                        vm.form.logoUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();

                        var imageSubmitForm = angular.copy(vm.form);
                        delete imageSubmitForm.coverImageUrl;
                        delete imageSubmitForm.description;
                    }

                    outletService.updateAppearance(imageSubmitForm).then((promise) => {
                        vm.updateStorefrontCallback(promise);
                    }, (promise) => {
                        vm.updateStorefrontCallback(promise);
                    });
                }
            });
        };

        // Clear the TYM if none desired
        vm.togglePurchaseThankYouMessage = function() {
            if (vm.form.useCustomThankYouMessage) {
            } else {
                vm.form.purchaseThankYouMessage = '';
            }
        };

        // Clear the ORM if none desired
        vm.toggleOrderReadyMessage = function() {
            if (!vm.form.useCustomOrderReadyMessage) {
                vm.form.orderReadyMessage = '';
            }
        };

        vm.validateFormContact = function() {
            vm.errors = null;
            let valid = true;
            const errors = {};
            angular.forEach(vm.outletOpeningHours, (day, index) => {
                day.error = false;
            }, valid);

            if (vm.business.useOpeningHours) {
                let daysOpen = 0;
                vm.outletOpeningHours.sort(
                    (a, b) => (a.givenIndex > b.givenIndex) ? 1 : ((b.givenIndex > a.givenIndex) ? -1 : 0)
                );

                angular.forEach(vm.outletOpeningHours, (day, index) => {
                    if (day.open) {
                        if (day.openingHour && day.closingHour) {
                            daysOpen++;
                            if (day.openingHour == day.closingHour) {
                                errors.openingHours = 'A day cannot open and close at the same time.';
                                valid = false;
                                day.error = true;
                            }
                        } else if (!day.openingHour || !day.closingHour) {
                            errors.openingHours = 'Please make sure all days that are marked as open ' +
                                'have an open and a close time specified.';
                            valid = false;
                            day.error = true;
                        }
                    }
                }, valid);
                if (daysOpen === 0) {
                    errors.openingHours = gettextCatalog
                        .getString('At least one day must be open and have an open and a close time specified');
                    valid = false;
                }
            }

            vm.errors = errors;

            return valid;
        };

        vm.saveStorefrontAppearance = function() {
            outletService.updateAppearance(vm.form).then((promise) => {
                vm.updateStorefrontCallback(promise);
            }, (promise) => {
                vm.updateStorefrontCallback(promise);
            });

            vm.saving = true;
        };

        vm.saveContactDetails = function() {
            if (!vm.validateFormContact()) {
                return;
            }

            outletService.getTimeZoneIdGoogle(vm.form.latitude, vm.form.longitude)
                .then(timeZoneRequestSuccess, timeZoneRequestFailed);

            function timeZoneRequestSuccess(response) {
                if (response.data && response.data.value) {
                    createSaveContactDetails(response.data.value);
                }
                else {
                    timeZoneRequestFailed('Zero results found');
                }
            }

            function timeZoneRequestFailed(reason) {
                $log.warn('Failed to get the timezone', reason);

                // If google timezone API cannot resolve timezone, select it from a list within a modal.
                if (utils.hasNoValue(vm.form.country)) {
                    messageService.error(gettextCatalog.getString('No country information found for this merchant'));
                    return;
                }

                const timezoneModalInstance = $uibModal.open({
                    template: require('../templates/timezone/timezone.html'),
                    controller: 'TimezoneController as timezoneCtrl',
                    windowClass: 'modal-small',
                    backdrop: 'static',
                    resolve: {
                        timezones() {
                            return vm.form.country.timezones;
                        }
                    }
                });

                timezoneModalInstance.result
                    .then((result) => {
                        if (result !== 'cancel') {
                            createSaveContactDetails(result);
                        }
                    },
                    (reason) => {
                        $log.warn(reason);
                    });
            }
        };

        // Handle the server response
        vm.updateStorefrontCallback = function(promise) {
            const response = promise;
            if (formHelper.handleResponse(response).isSuccess()) {
                vm.saving = false;
                messageService.saveAlert();

                // Update merchant info in cache for dashboard
                merchantService.refreshMerchantInfo();

                outletService.refreshOutletInfo(null);

                // Set lat/long to pristine true after save, it means hasn't been changed
                if (vm.formContact) {
                    vm.formContact.latitude.$pristine = true;
                    vm.formContact.longitude.$pristine = true;
                }
            } else {
                // An error has occurred, re-enable the button
                vm.saving = false;
                messageService.errorWithReason(response, null, true);
            }
        };

        vm.applyAll = function(day) {
            angular.forEach(vm.outletOpeningHours, (changeDay) => {
                changeDay.openingHour = day.openingHour;
                changeDay.closingHour = day.closingHour;
                changeDay.open = day.open;
            });
        };

        vm.emptyDay = function(day) {
            day.openingHour = '';
            day.closingHour = '';
        };

        function setSelectorHours() {
            let str;
            const date = new Date();
            const interval = 30;
            vm.hours = [];
            date.setHours(0);
            date.setMinutes(0);
            for (let i = 0; i < 24 * (60 / interval); i++) {
                str = '' + ((date.getHours() < 10 ? '0' +
                    date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() :
                        date.getMinutes()));

                vm.hours.push({name: str, value: str, id: str});
                date.setMinutes(date.getMinutes() + interval);
            }
        }

        function convertOpeningHoursMapToArray(openDays) {
            const openingHoursArray = [];

            angular.forEach(openDays, (day, key) => {
                const convertDay = {};
                convertDay.label = key;
                convertDay.openingHour = day.openingHour;
                convertDay.closingHour = day.closingHour;
                convertDay.open = day.open;
                convertDay.givenIndex = day.index;
                openingHoursArray.push(convertDay);
            });
            return openingHoursArray;
        }

        function convertOpeningHoursArrayToMap(openingHours) {
            const openingHoursMap = {};

            angular.forEach(openingHours, (day) => {
                const convertDay = {};
                const label = day.label;
                convertDay.openingHour = day.openingHour;
                convertDay.closingHour = day.closingHour;
                convertDay.open = day.open;
                convertDay.index = day.givenIndex;
                openingHoursMap[label] = convertDay;
            });
            return openingHoursMap;
        }

        function isTimeZoneDefined() {
            return vm.form.timezoneId;
        }

        function createSaveContactDetails(timeZoneId) {
            if (vm.business.useOpeningHours) {
                vm.form.outletOpeningHours = {
                    openDays: convertOpeningHoursArrayToMap(vm.outletOpeningHours)
                };
            } else {
                vm.form.outletOpeningHours = null;
            }
            if (timeZoneId) {
                vm.form.timezoneId = timeZoneId;
            }
            outletService.saveContactDetails(vm.form).then((promise) => {
                vm.updateStorefrontCallback(promise);
            }, (promise) => {
                vm.updateStorefrontCallback(promise);
            });

            vm.saving = true;
        }

    }



// WEBPACK FOOTER //
// ./src/controllers/storefront.controller.js